// extracted by mini-css-extract-plugin
export var quillEditor = "_hq-1";
export var variable = "_hq-0";